<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <div class="shortLink-table">
      <tableList ref="multipleTable" size="small" :query-function="$Api.shortLink.postShortLink" style="width: 100%" :cell-dblclick="handleCellDbClick">
        <el-table-column prop="id" label="短链ID" width="100" />
        <el-table-column prop="mpLink" label="原始链接" />
        <el-table-column prop="shortLink" label="短链" width="auto" />

        <el-table-column prop="createTime" label="时间" width="150px">
          <template v-slot="{row}">
            <span> {{ formatTime(row.createTime) || '--' }} </span>
          </template>
        </el-table-column>
      </tableList>
      <el-dialog v-if="showAddDialog" top="30vh" :close-on-click-modal="false" :visible.sync="showAddDialog" title="新增小程序短链" custom-class="add-dialog" @close="handleDialogClose">
        <el-form :model="form" label-width="100">
          <el-form-item label="原始链接">
            <el-input v-model="form.mpUrl" type="textarea" placeholder="请输入小程序原始链接" style="max-width:552px;" />
          </el-form-item>
          <el-form-item>
            <div class="center">
              <el-button type="primary" @click="handleAddShortLink">生成短链</el-button>
            </div>
          </el-form-item>
        </el-form>
        <div v-if="shortLink" class="copy-box">
          <span>小程序短链：</span>
          <div class="link" :title="shortLink">
            <span>
              {{ shortLink }}
            </span>
          </div>
          <el-button type="primary" size="small" @click="copy">复制</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import moment from 'moment';
import { generateShortLink } from '@/api/shortLink';
import FunctionUtils from "@/utils/functionUtils";
export default {
  components: { tableList },
  data() {
    return {
      showAddDialog: false,
      form: {
        mpUrl: '',
      },
      shortLink: '',
    };
  },

  methods: {

    formatTime(val) {
      if (val) return moment(val).format('YYYY/MM/DD HH:mm:ss');
      return '';
    },
    add() {
      this.form.mpUrl = '';
      this.showAddDialog = true;
    },
    handleDialogClose() {
      this.showAddDialog = false;
      this.shortLink = '';
    },
    handleAddShortLink() {
      if (!this.form.mpUrl) {
        this.$message.warning('请先输入小程序原始链接');
        return;
      }
      const fn = () => {
        generateShortLink(this.form).then(res => {
          if (res) {
            this.shortLink = res;
            this.$refs['multipleTable'].getTableList();
          }
        });
      };
      FunctionUtils.throttle(fn, 1000);
    },
    copy() {
      navigator.clipboard.writeText(this.shortLink).then(() => {
        this.$message.success('复制成功');
      });
    },
    handleCellDbClick(row, column) {
      if (column.property && column.property === 'shortLink') {
        if (!row.shortLink) return;
        navigator.clipboard.writeText(row.shortLink).then(() => {
          this.$message.success('复制短链成功');
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.shortLink-table {
  /deep/.add-dialog {
    .el-dialog__header {
      background: #000000;
      height: 74px;
      padding: 25px 30px;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 31px;
        right: 31px;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 30px;
      .center {
        display: flex;
        justify-content: center;
      }
      .copy-box {
        display: flex;
        align-items: center;
        border-top: 1px solid #e3e3e5;
        padding-top: 20px;
        .link {
          width: 457px;
          height: 34px;
          white-space: nowrap;
          overflow-x: hidden;
          text-overflow: ellipsis;
          background: #eeeeee;
          border: 1px solid #e3e3e5;
          border-radius: 4px;
          padding: 7px 10px;
          line-height: 20px;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
